/**
 * Bir metnin sadece ilk harfini büyütür.
 * @param {string} s - Formatlanacak metin
 * @param {string} locale - Dil seçeneği (Türkçe karakter uyumu için 'tr-TR' önerilir)
 */
export const capitalize = (s, locale = 'tr-TR') =>
  s && s.length > 0 && s[0].toLocaleUpperCase(locale) + s.slice(1).toLocaleLowerCase(locale)

/**
 * Bir metindeki her kelimenin ilk harfini büyütür.
 */
export const capitalizeWords = (s, locale = 'tr-TR') => {
  if (!s || s.length === 0) return ""

  return s
    .split(" ")
    .map(word =>
      word.charAt(0).toLocaleUpperCase(locale) +
      word.slice(1).toLocaleLowerCase(locale),
    )
    .join(" ")
}

/**
 * Bir metni ters çevirir.
 */
export const reverse = s => s && s.split``.reverse().join``

/**
 * Telefon numarasını maskeler.
 * phoneMask("5551234567")	"0(555) 123 45 67"
 */
export const phoneMask = value => {
  if (!value) return ""

  // Sadece rakamları al
  let cleaned = value.toString().replace(/\D/g, "")

  // Eğer başında 0 yoksa ekle
  if (cleaned.length === 10) cleaned = "0" + cleaned

  return cleaned.replace(
    /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/,
    "0($2) $3 $4 $5",
  )
}

export const phoneMask2 = value => {
  if (!value) return ""

  let cleaned = value.toString().replace(/\D/g, "")
  if (cleaned.length === 10) cleaned = "0" + cleaned

  return cleaned.replace(
    /^(\d{4})(\d{7})$/,
    "$1 $2",
  )
}

/**
 * IBAN numarasını maskeler.
 * ibanMask("TR0000000000000000000000")	"TR00 0000 0000 0000 0000 00"
 */
export const ibanMask = value => {
  if (!value) return ""
  value = value.toString()

  return value
    .replace(/\s+/g, "")
    .toUpperCase()
    .replace(/(.{4})/g, "$1 ")
    .trim()
}
